var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatMessageComposerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 272,
    height: 82.071,
    viewBox: "0 0 272 82.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160888",
    "data-name": "Group 160888",
    transform: "translate(-950 -603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160887",
    "data-name": "Group 160887"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2045",
    "data-name": "Rectangle 2045",
    d: "M0,0H272a0,0,0,0,1,0,0V69.071a13,13,0,0,1-13,13H13a13,13,0,0,1-13-13V0A0,0,0,0,1,0,0Z",
    transform: "translate(950 603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160702",
    "data-name": "Group 160702",
    transform: "translate(8 -13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160573",
    "data-name": "Group 160573"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Powered_by_Falkon_Systems",
    "data-name": "Powered by Falkon Systems",
    transform: "translate(1050.807 683.242)",
    fill: "#818792",
    fontSize: 5,
    fontFamily: "Silka-Light, Silka",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Powered by Falkon "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Silka-Regular, Silka",
    fontWeight: 400
  }, "Systems")), /*#__PURE__*/React.createElement("g", {
    id: "Falkon_SYSTEMS-01",
    "data-name": "Falkon SYSTEMS-01",
    transform: "translate(1040.193 678.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M175.835,214.568a6.37,6.37,0,0,1-1.322-2.168,2.91,2.91,0,0,0-.214.8c-.021.256-.132,1.024,1.012,2.1a2.662,2.662,0,0,1,1.111,1.94c-.233-1.271-2.15-1.923-2.274-2.9a3.16,3.16,0,0,0,1.4,3.14c1.3,1.025-.23,2.918-1.412,3.85a5.561,5.561,0,0,0,2.713-2.924A3.448,3.448,0,0,0,175.835,214.568Z",
    transform: "translate(-174.125 -212.4)",
    fill: "#647084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M585.417,603.626c-.487-.176-.809.092-1.239.261a3.427,3.427,0,0,1-.054,3.417,4.268,4.268,0,0,1-.624,1.006h0a7.034,7.034,0,0,0,1.55-2.784l.017-.073c.379-1.454,1.064-.991,1.065-.991A1.228,1.228,0,0,0,585.417,603.626Z",
    transform: "translate(-581.518 -600.987)",
    fill: "#647084"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2046",
    "data-name": "Rectangle 2046",
    transform: "translate(963.569 613.424)",
    fill: "#fff",
    stroke: "#efefef",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.577,
    height: 33.576,
    rx: 16.788,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32.577,
    height: 32.576,
    rx: 16.288,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160703",
    "data-name": "Group 160703",
    transform: "translate(1176.967 613.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_1_28",
    "data-name": "Component 1 \\u2013 28",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 16.788,
    cy: 16.788,
    r: 16.788,
    fill: "#1450ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "send",
    d: "M28.21,52.82l0,0L16.884,48.062a.618.618,0,0,0-.589.058.664.664,0,0,0-.3.553v3.042a.642.642,0,0,0,.517.633L22.692,53.5a.108.108,0,0,1,0,.211l-6.175,1.156A.642.642,0,0,0,16,55.5v3.042a.634.634,0,0,0,.631.636.644.644,0,0,0,.252-.052L28.205,54.4l.005,0a.864.864,0,0,0,0-1.579Z",
    transform: "translate(-4.594 -36.89)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160704",
    "data-name": "Group 160704",
    transform: "translate(1003.861 613.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2042",
    "data-name": "Rectangle 2042",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#efefef",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166.391,
    height: 33.576,
    rx: 16.788,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 165.391,
    height: 32.576,
    rx: 16.288,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Send_us_a_message_",
    "data-name": "Send us a message!",
    transform: "translate(12.446 10.026)",
    fill: "#868686",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "Send us a message!")), /*#__PURE__*/React.createElement("g", {
    id: "Group_160674",
    "data-name": "Group 160674",
    transform: "translate(146.312 10.026)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1944",
    "data-name": "Rectangle 1944",
    width: 12.438,
    height: 13.525,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "smile",
    transform: "translate(0 0.691)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 5.873,
    cy: 5.726,
    rx: 5.873,
    ry: 5.726,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#647084",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M8,14a3.146,3.146,0,0,0,4.153,0",
    transform: "translate(-4.132 -7.327)",
    fill: "none",
    stroke: "#647084",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 0.004,
    transform: "translate(4.38 3.547)",
    fill: "none",
    stroke: "#647084",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 0.004,
    transform: "translate(7.511 3.547)",
    fill: "none",
    stroke: "#647084",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160706",
    "data-name": "Group 160706",
    transform: "translate(974.461 623.992)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1945",
    "data-name": "Rectangle 1945",
    width: 12.438,
    height: 12.438,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "attach-outline",
    d: "M162.247,82.931v4.56a1.27,1.27,0,1,0,2.541,0l0-5.977a2.154,2.154,0,1,0-4.307,0v6.017a3.028,3.028,0,1,0,6.055,0V81.908",
    transform: "translate(-157.643 -78.886)",
    fill: "none",
    stroke: "#647084",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatMessageComposerIcon);
export default __webpack_public_path__ + "static/media/live-chat-message-composer-icon.2889a59ec9410e08aac8ccdafc90ac0f.svg";
export { ForwardRef as ReactComponent };